import type { RupturaDigitalRecord } from '../types/payload'

export const DIGITAL_CHANNEL_KEY = 'digital_nativo'

export function excludeDigitalChannel<T extends { canal: string }>(records: T[]): T[] {
  return records.filter(record => record.canal !== DIGITAL_CHANNEL_KEY)
}

/**
 * Checks-weighted average stockout rate across the "geral" (not MP-scoped)
 * records, excluding the Digital channel — the presentation-layer
 * recalculation for the "Ruptura Global" KPI. The raw payload's own
 * totals.stockout_pct is a single backend-computed scalar over every
 * channel including Digital, so it can't be reused here; this stays a
 * pure frontend derivation and never touches the underlying JSON.
 */
export function calculateGlobalRupturePctExcludingDigital(records: RupturaDigitalRecord[]): number {
  const geralRecords = excludeDigitalChannel(records).filter(record => record.metric_scope === 'geral')
  const totalChecks = geralRecords.reduce((sum, record) => sum + record.checks, 0)
  const totalStockouts = geralRecords.reduce((sum, record) => sum + record.stockouts, 0)

  return totalChecks === 0 ? 0 : totalStockouts / totalChecks
}
